module.exports = __webpack_public_path__ + "img/eduID_color.bc16333b.svg";